import { AppConfig } from './definitions/app-config.interface';

function updateTitle(title: string): void {
  document.title = title;
}

function updateFavicon(theme: string): void {
  const link = document.createElement('link');
  link.rel = 'icon';
  link.type = 'image/x-icon';
  link.href = `assets/favicons/favicon-${theme}.ico`;
  document.head.appendChild(link);
}

export function applyTheme(config: AppConfig): Promise<void> {
  const companyInfo = config.companyInfo;

  updateFavicon(companyInfo.theme);
  updateTitle(companyInfo.appName);

  return Promise.resolve();
}
